import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * 分页 for the lists in 客户记录 → 全部记录 (and the 客户情况 notes list).
 * `pageSlice(items, page)` clamps the page and returns the slice to render; <RecPager> draws
 * 上一页 · 第 x / y 页 · 下一页 and hides itself when everything fits on one page.
 */
export const REC_PAGE_SIZE = 20;

export function pageSlice(items, page, size = REC_PAGE_SIZE) {
  const list = Array.isArray(items) ? items : [];
  const pages = Math.max(1, Math.ceil(list.length / size));
  const pg = Math.min(Math.max(1, Number(page) || 1), pages);
  return { slice: list.slice((pg - 1) * size, pg * size), page: pg, pages, total: list.length };
}

const btn = (disabled) => ({
  height: 32, minWidth: 32, padding: '0 10px', borderRadius: 2, border: '1px solid rgba(17,17,17,.2)',
  background: 'transparent', color: disabled ? 'rgba(17,17,17,.3)' : '#111111', cursor: disabled ? 'default' : 'pointer',
  fontFamily: 'inherit', fontSize: 12.5, display: 'inline-flex', alignItems: 'center', gap: 4,
});

export default function RecPager({ page, pages, total, onPage, isZh }) {
  if (!pages || pages <= 1) return null;
  const t = (zh, en) => (isZh ? zh : en);
  const go = (p) => { if (p >= 1 && p <= pages && p !== page) onPage(p); };
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '12px 0 4px', flexWrap: 'wrap' }}>
      <button type="button" onClick={() => go(page - 1)} disabled={page <= 1} style={btn(page <= 1)} aria-label={t('上一页', 'Previous page')}>
        <ChevronLeft size={14} />{t('上一页', 'Prev')}
      </button>
      <span style={{ fontSize: 12.5, color: '#3A3835' }}>
        {t(`第 ${page} / ${pages} 页 · 共 ${total} 条`, `Page ${page} / ${pages} · ${total} total`)}
      </span>
      <button type="button" onClick={() => go(page + 1)} disabled={page >= pages} style={btn(page >= pages)} aria-label={t('下一页', 'Next page')}>
        {t('下一页', 'Next')}<ChevronRight size={14} />
      </button>
    </div>
  );
}
